import classNames from 'classnames';

import CenteredContent from '@picsart/rc/old/CenteredContent';

import useStyles from './styles';

import { HowToOldVersionProps } from './types';

function HowToOldVersionFallback({ steps }: Partial<HowToOldVersionProps>) {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <CenteredContent>
        <div className={styles.skeletonTitle}>
          <i className="skeleton" />
        </div>
        <div className={styles.containerHolder}>
          {steps.map((step, index) => (
            <ul className={styles.container} key={index}>
              <li className={styles.column} key={index + 1}>
                <i className={classNames(styles.number, 'skeleton')} />
                <div className={styles.skeletonStepWrapper}>
                  <i className="skeleton" />
                </div>
              </li>
            </ul>
          ))}
        </div>
      </CenteredContent>
    </div>
  );
}

export default HowToOldVersionFallback;
